export const SET_WIDGET_DATA = 'SET_WIDGET_DATA';
